let STRIPE_KEY: string; /// TODO: THIS SHOULD BE SET BY THE PROCESS; PENDING UNTIL WE WILL HAVE NODEJS SERVER

if (process.env.REACT_APP_API_ENDPOINT === 'http://169.48.29.83:8000/api/v1') {
  STRIPE_KEY = 'pk_test_j65QOujCjrPkhLURdER1wenm';
} else {
  STRIPE_KEY = 'pk_live_bRxXVsgck30LxGPJ8QOn4dAm';
}

export { STRIPE_KEY };
